import { AfterViewInit, Component, HostBinding, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AccountsService } from 'src/app/accounts/accounts.service';
import { WhiteLabelService } from 'src/app/white-label/white-label.service';
import {
  DrawerComponent,
  MenuComponent,
  ScrollComponent,
  ScrollTopComponent,
  StickyComponent,
  ToggleComponent,
} from '../../_metronic/kt/components';
import { AclService } from '../../acl/acl.service';

@Component({
  selector: 'app-errors',
  templateUrl: './errors.component.html',
  styleUrls: ['./errors.component.scss'],
})
export class ErrorsComponent implements OnInit, AfterViewInit {
  @HostBinding('class')
  public class: string = 'd-flex flex-column flex-root';

  constructor(
    public readonly whiteLabelService: WhiteLabelService,
    private accountsService: AccountsService,
    private aclService: AclService,
    private router: Router,
  ) {}

  public ngAfterViewInit(): void {
    if (this.router.url.includes('keycloak')) {
      this.routeToDashboard();
    }
  }

  public ngOnInit() {
    setTimeout(() => {
      this.accountsService.terminateAccountsLoading();
      this.aclService.terminateLoading();
    }, 500);
  }

  public routeToDashboard() {
    this.router.navigate(['/']);
    setTimeout(() => {
      ToggleComponent.bootstrap();
      ScrollTopComponent.bootstrap();
      DrawerComponent.bootstrap();
      StickyComponent.bootstrap();
      MenuComponent.bootstrap();
      ScrollComponent.bootstrap();
    }, 200);
  }
}
